<template>
  <button
    v-tag:useractionevent="{
      action: 'display',
      category: 'internal search',
      ecommerce: undefined,
      event: 'uaevent',
      label: 'search',
    }"
    aria-controls="search"
    :aria-expanded="searchMobileOpened"
    :class="['search-trigger', { 'open': searchMobileOpened }]"
    @click="toggleSearch"
  >
    <slot />
    <span
      class="is-sr-only"
      aria-live="polite"
      v-text="searchMobileOpened ? 'close search' : 'open search'"
    />
  </button>
</template>

<script>
  import { tag } from '@Foundation/analyticsHandler/directives/tag';
  import { mapActions, mapGetters } from 'vuex';
  export default {
    name: 'SearchToggle',
    directives: {
      tag
    },
    computed: {
      ...mapGetters('searchStore', [
        'searchMobileOpened'
      ]),
    },
    methods: {
      ...mapActions('searchStore', [
        'setSearchMobileOpened'
      ]),
      toggleSearch() {
        this.setSearchMobileOpened(!this.searchMobileOpened);
      }
    }
  };
</script>
